import { useEffect, useRef } from 'react';

const compareInputs = (oldInputs, newInputs) => {
	const ret = [];
	Object.keys(newInputs).forEach((key) => {
		const newInput = newInputs?.[key];

		if (oldInputs) {
			const oldInput = oldInputs?.[key];
			if (oldInput !== newInput) {
				ret.push({ key, oldInput, newInput });
			}
		} else {
			ret.push({ key, newInput });
		}
	});
	return ret;
};

/**
 * Log arbitrary values and their changes over time.
 * Useful for debugging re-renders / state-changes / mount-data of components and hooks.
 *
 * Example usage:
 *
 * useMyHook: ({param1, param2, debug})=>{
 *    const [state,setState] = useState();
 *    ...
 *    // eslint-disable-next-line react-hooks/rules-of-hooks
 *    debug && useDebugger('Grid', {param1,param2,state});
 *   ...
 * }
 *
 */
export const useDebugger = (label, inputs) => {
	const isFirst = useRef(true);
	const oldInputsRef = useRef();

	// This effect will run on each render.
	useEffect(() => {
		const groupLbl = isFirst.current ? `${label} [mounted]` : label;
		if (isFirst.current) {
			isFirst.current = false;
		}
		const diff = compareInputs(oldInputsRef.current, inputs);
		console.group(groupLbl);
		console.table(diff);
		console.groupEnd(groupLbl);

		oldInputsRef.current = inputs;
	});
};
